import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import { useDispatch } from "react-redux";
import { setOpenFacilitySelect } from "../../store/config/configActions";
import { useHistory } from "react-router";

interface IProps {
  rootClass: any;
  textClass: any;
}

const ChangeFacilityButton: React.FC<IProps> = ({ rootClass, textClass }: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleChnageFacility = () => {
    history.push("/");
    dispatch(setOpenFacilitySelect(true));
  };
  return (
    <React.Fragment>
      <Link onClick={() => handleChnageFacility()} component={"li"} style={{ textDecoration: "none" }}>
        <ListItem button classes={{ root: rootClass }} style={{marginTop: 10}}>
          <ListItemText classes={{ primary: textClass }} primary={"Zmień obiekt"} />
        </ListItem>
        <Divider />
      </Link>
    </React.Fragment>
  );
};

export default ChangeFacilityButton;
